export default __webpack_public_path__ + "static/media/Background_00145.a28c1084.png";